import type { ICoreEvent } from '../types/core-event'
import type { IApiClientMeta } from './types'

export const PUBLIC_API_CORRELATION_PREFIX = 'pa_'

export type AttributionEvent = Pick<ICoreEvent, 'correlationId' | 'apiClient'>

// Structural so both react-intl's formatMessage and the backend IntlFormatters fit.
export type AttributionFormatMessage = (descriptor: { id: string }, values: { name: string; integrationName: string }) => string

export function isPublicApiCorrelationId(id?: string): boolean {
  return !!id && id.startsWith(PUBLIC_API_CORRELATION_PREFIX)
}

export function mapApiClientsByCorrelation(events: AttributionEvent[]): Map<string, IApiClientMeta> {
  const apiClientsByCorrelation = new Map<string, IApiClientMeta>()
  for (const { correlationId, apiClient } of events) {
    if (apiClient && !apiClientsByCorrelation.has(correlationId)) apiClientsByCorrelation.set(correlationId, apiClient)
  }
  return apiClientsByCorrelation
}

export interface ResolveEventApiClientParams {
  event: AttributionEvent
  apiClientsByCorrelation: Map<string, IApiClientMeta>
}

export function resolveEventApiClient(params: ResolveEventApiClientParams): IApiClientMeta | undefined {
  const { event, apiClientsByCorrelation } = params
  if (event.apiClient) return event.apiClient
  if (!isPublicApiCorrelationId(event.correlationId)) return undefined
  return apiClientsByCorrelation.get(event.correlationId)
}

export interface FormatApiClientAttributionParams {
  name: string
  integrationName?: string
  formatMessage: AttributionFormatMessage
}

export function formatApiClientAttribution(params: FormatApiClientAttributionParams): string {
  const { name, integrationName, formatMessage } = params
  if (!integrationName) return name
  return formatMessage({ id: 'app.attribution.throughIntegration' }, { name, integrationName })
}

export interface DecorateApproverNamesParams {
  approverList: { id: string; name: string }[]
  approverId?: string
  integrationName?: string
  formatMessage: AttributionFormatMessage
}

export function decorateApproverNames(params: DecorateApproverNamesParams): string[] {
  const { approverList, approverId, integrationName, formatMessage } = params
  return approverList.map(({ id, name }) => (integrationName && id === approverId ? formatApiClientAttribution({ name, integrationName, formatMessage }) : name))
}
